canUseHistory